// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__VWnBJ","productName":"Table_productName__3etPC"};